<mat-toolbar class="header" color="primary">
  <div class="header__title">
    <button
      class="header__title-button"
      mat-mini-fab
      (click)="openMenu()"
      color="primary">
      <mat-icon class="header__title-button-icon">menu</mat-icon>
    </button>
    <h6 class="header__title-text">
      {{ (auth.brandLockedSubject | async) || "Super Streaming" | titlecase }}
      Admin ({{ projectId }})
    </h6>
  </div>

  <div class="header-toolbar">
    <app-user [user]="auth.user$ | async" (signOut)="signOut()"></app-user>
  </div>
</mat-toolbar>
